import DownloadApp from '@components/icons/DownloadApp.svg';
import Hammer from '@components/icons/Hammer.svg';
import CrossIcon from '@components/icons/SidebarCross.svg';
import VideoIcon from '@components/icons/Video.svg';
import { getDownloadDesktopAppLink } from '@helpers/getDownloadDesktopAppLink';
import { useAPI } from '@providers/useAPI';
import { routes } from '@routes';
import { useMutation } from '@tanstack/react-query';
import { UserService } from 'app/API';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

export const DownloadDesktopCard = () => {
  const { call } = useAPI();
  const downloadedClientMutation = useMutation({
    mutationFn: () => call(() => UserService.downloadedClient()),
  });
  const [isDisabled, setIsDisabled] = useState(window.localStorage.getItem('disableDownloadDesktopCard'));

  const close = () => {
    window.localStorage.setItem('disableDownloadDesktopCard', 'true');
    setIsDisabled('true');
  };

  if (isDisabled) {
    return null;
  }

  return (
    <div className="p-2.5 -m-2.5 relative w-[240px]">
      <div className="h-[170px] bg-gradient-to-r from-[var(--color-banner-gradient-from)] to-[var(--color-banner-gradient-to)] rounded-[5px] flex flex-col relative text-left w-full">
        <div className="overflow-hidden relative px-[25px] h-full">
          <div
            className="absolute top-2.5 right-2.5 cursor-pointer text-[var(--color-surface)] hover:text-[var(--color-banner-button-text)]"
            onClick={close}
          >
            <CrossIcon />
          </div>
          <div className="font-semibold text-base leading-5 text-[var(--color-surface)] mt-[25px] w-[180px]">
            Get the Desktop Editor
          </div>
          <div className="font-medium text-xs leading-[130%] text-[var(--color-surface)] mt-2.5 text-left">
            Enhanced editing features and audio player
          </div>
          <a
            className="peer mt-2.5 mx-auto font-medium text-xs leading-[130%] bg-[var(--color-banner-button-bg)] flex justify-center items-center gap-2.5 w-[170px] h-[30px] text-[var(--color-banner-button-text)] rounded-[5px] no-underline relative z-[2] shadow-lg hover:bg-[var(--color-banner-button-hover)]"
            href={getDownloadDesktopAppLink()}
            onClick={() => downloadedClientMutation.mutate()}
            target="_blank"
            rel="noreferrer"
          >
            <DownloadApp />
            Download AutoScript
          </a>
          <Hammer className="absolute w-[124px] p-[27px] h-[124px] bottom-[22px] left-[145px] z-[1] transition-all duration-100 ease-in-out peer-hover:scale-[1.3] rounded-full bg-[#ffffff1a]" />
          <RouterLink
            to={routes.desktopAppHelp.make()}
            className="flex mt-2.5 font-medium text-xs leading-[150%] text-[var(--color-surface)] hover:text-[var(--color-banner-button-hover)] cursor-pointer underline gap-[5px] items-center justify-center"
          >
            <VideoIcon />
            Check our Editor Guide
          </RouterLink>
        </div>
      </div>
    </div>
  );
};
